import { SellerRoleInfo } from 'src/WebApiController';

import { SellerRoleModal } from './SellerRoleModal';

export const getSellerRoleModalConfig = (roleInfo?: SellerRoleInfo | null) => ({
  children: <SellerRoleModal roleInfo={roleInfo} />,
  clickOutsideToClose: true,
  size: 'slide-in',
});
